import CallServer from '../../api/CallServerV2';
export async function fetchOperations () {
    return await CallServer({
        endpoint: '/admin/get_operations',
        retryIfFailed: true,
        isGet: true
    })
} 